import { realBricksApi } from '../../utils/axiosInterceptors';
import { getStaticMapImageURL } from '../MapboxAPIs';

export const getPropertyDetails = async (data, { rejectWithValue }) => {
  const { id, orderId, onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/properties/detail/${id}`, {
      params: orderId ? { orderId } : undefined,
    });
    if (response?.data?.data?.latitude && response?.data?.data?.longitude) {
      response.data.data['mapImage'] = getStaticMapImageURL({ lat: response?.data?.data?.latitude, lon: response?.data?.data?.longitude });
    }
    onSuccess();
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};
export const getTradeDetails = async (data, { rejectWithValue }) => {
  const { id, onFail = () => {} } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/properties/insides/${id}`);
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};
export const getChartData = async (data) => {
  const { id, type } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/properties/chart-data/${id}/${type}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const addSellPropertyService = (body) => {
  return realBricksApi.post(`/api/v1/properties/sell`, body);
};
